// Drop utils
import ElementDropTarget from '../../../../element/dnd/elementDropTargets/ElementDropTarget';

import makeCanDropFn from '../../../../element/dnd/canDrop/makeCanDropFn';
import preventLine from '../../../../element/dnd/canDrop/preventLinePredicate';

// Constants
import { DROP_TARGET_TYPES } from '../../../../../common/elements/elementConstants';

const dropTargetConfig = {
    // ignore drop results
    drop: () => undefined,
    hoverType: DROP_TARGET_TYPES.NONE,
    canDrop: makeCanDropFn([preventLine]),
    collect: (monitor) => ({
        isHovered: monitor.canDrop() && monitor.isOver({ shallow: false }),
        // Requires canDrop for the breadcrumb highlighting
        canDrop: monitor.canDrop(),
    }),
};

export default ElementDropTarget(dropTargetConfig);
